<template>
    <div class="p-6 pb-4 text-center">
        <div class="text-gray-400 mb-3">
            <IconSearchNoResults />
        </div>
        <p class="text-gray-500 text-sm font-medium">
            {{ t('common.fulltext_search.no_results') }}
        </p>
        <p class="text-gray-400 text-xs mt-1">
            {{ t('common.fulltext_search.no_results_hint') }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import IconSearchNoResults from '~/components/icons/IconSearchNoResults.vue';
    import { useI18n } from 'vue-i18n';
    
    const { t } = useI18n();
</script> 
